import { Stack, Typography } from "@mui/material";
import { MprcChipChoice, MprcContainer, MprcRequestErrorDialog, MprcSpinnerIndicator } from "components";
import { TrainingPanelTopicResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
    trainingId: string;
}

/**
 * Painel lateral para tópicos do treinamento.
 * @param props
 */
export const TrainingViewTopicBox: React.FC<IProps> = (props) => {
    const { trainingId } = props;

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const navigate = useNavigate();

    const [topics, setTopics] = useState<TrainingPanelTopicResponse[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [viewError, setViewError] = useState<any>();

    const handleClick = (item: TrainingPanelTopicResponse) => {
        if ((item.publicationCount ?? 0) > 0) {
            navigate(KnowledgePaths.FeedTopic(item.topicId));
        } else {
            navigate(KnowledgePaths.FeedTopicTrainings(item.topicId));
        }
    };

    /////////////////////////////////////////////////////////////
    /// Effect
    /////////////////////////////////////////////////////////////

    useEffect(() => {
        async function getData() {
            try {
                var result = await api.v1.enrollment.getTrainingPanelTopics({
                    trainingId
                });
                setTopics(result.data);
            } catch (e) {
                setViewError(e);
            } finally {
                setLoading(false);
            }
        }

        if (loading) getData();

    }, [loading]);

    /////////////////////////////////////////////////////////////
    /// Render
    /////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(undefined)} />
            {
                loading
                    ? (
                        <MprcContainer margin="dense">
                            <MprcSpinnerIndicator />
                        </MprcContainer>
                    )
                    : (
                        <>
                            {
                                topics.length > 0
                                    ?
                                    <div>
                                        <MprcContainer margin="dense">
                                            <Typography variant="h3">{t("Student.EnrollmentView.TopicBox.Title")}</Typography>
                                        </MprcContainer>
                                        <MprcContainer margin="dense">
                                            <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap" columnGap={0} rowGap={1}>
                                                {topics.map(item =>
                                                    <MprcChipChoice
                                                        label={item.name}
                                                        key={item.topicId}
                                                        selected={false}
                                                        maxWidth="250px"
                                                        onClick={() => handleClick(item)}
                                                    />
                                                )}
                                            </Stack>
                                        </MprcContainer>
                                    </div>
                                    :
                                    null
                            }
                        </>
                    )
            }
        </>
    );
};
